import React, { useEffect, useRef } from "react";
import { Col, Row } from "react-bootstrap";
import PopoverBtn from "../../popoverBtn";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useSelector } from "react-redux";
import classNames from "classnames";

const InputPhone = (props) => {
  const {
    children,
    popoverText,
    error,
    valid,
    fullWidth,
    multiInput,
    ...params
  } = props;
  const { lang } = useSelector((state) => ({
    lang: state.changeLang.language.stepTwo.phoneNumber,
  }));
  const ref = useRef(null);
  useEffect(() => {
    if (!params.value) {
      ref.current.state.formattedNumber = "";
    }
  }, []);

  const multiInputClass = fullWidth && multiInput ? "me-5" : "me-3";

  return (
    <>
      <Row className="align-items-center flex-nowrap position-relative mb-3">
        <Col xs={12} md={fullWidth ? 12 : 11}>
          <PhoneInput
            {...params}
            ref={ref}
            country={"us"}
            enableLongNumbers={true}
            placeholder={lang[0]}
            containerClass="react-tel-input"
            inputClass={classNames("form-control ps-5 w-100 text-black-title", {
              "border-danger": error,
              "border-success": valid,
            })}
            inputStyle={{ height: "58px", fontSize: "16px" }}
            buttonStyle={{ backgroundColor: "white", borderRight: "none" }}
            buttonClass={classNames("", {
              "border-danger": error,
              "border-success": valid,
            })}
          />
          {children}
        </Col>

        <div
          className={classNames(
            "position-absolute top-0 end-0 mt-3 w-auto",
            multiInputClass
          )}
        >
          <PopoverBtn text={popoverText} />
        </div>
      </Row>
    </>
  );
};
export default InputPhone;
